import { useOverlayContext } from '~/contexts';
import { useLegalTerms } from '~/hooks/reactQuery/queries/useLegalTerms';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { useAppConfig, useStoreActions } from '~/store/store-context';
import { copiedDocumentNameTextsPath, generateUniqueCopyName } from './generateUniqueCopyName';
export const useDuplicateLegalTerms = ()=>{
    const { api } = useStoreActions();
    const { showSuccessToast, showErrorToast } = useOverlayContext();
    const { generateUniqueId } = useAppConfig();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: copyNameTexts } = useLocaleKeys(copiedDocumentNameTextsPath);
    const { legalTerms, refresh } = useLegalTerms();
    const duplicateLegalTerms = async (legalTerm)=>{
        const existingNames = legalTerms.map((existing)=>existing.name);
        const newName = generateUniqueCopyName(legalTerm.name, existingNames, copyNameTexts);
        const result = await handleRequest(api.business.createQuillLegalTerms({
            id: generateUniqueId('legalTerms'),
            name: newName,
            content: JSON.stringify(legalTerm.richTextContent)
        }));
        void refresh();
        if (!result.success) {
            showErrorToast(commonTexts.toasts.anUnknownErrorHasOccurred());
            return;
        }
        showSuccessToast(commonTexts.toasts.documentDuplicatedSuccessfully());
    };
    return {
        duplicateLegalTerms
    };
};
